/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Divider } from 'components/divider/Divider'
import { useFlags } from 'config/useFlagsContext'
import { useMedicamentoUsoModalQuery } from 'graphql/hooks.generated'
import { ReceitaMedicamento } from 'graphql/types.generated'
import { Fragment, useMemo } from 'react'
import { getMedicamentosAgrupados } from 'view/atendimentos/detail/soap/plano/prescricao-medicamento/utils/utils-prescricao'

import { AcompanhamentoAccordionCard } from '../../components/AcompanhamentoAccordionCard'
import { MedicamentoEmUsoSection } from './MedicamentoEmUsoSection'

interface MedicamentosEmUsoCardProps {
  prontuarioId: ID
}

export function MedicamentosEmUsoCard(props: MedicamentosEmUsoCardProps) {
  const { prontuarioId } = props
  const { RENOVACAO_PRESCRICAO_ENABLED } = useFlags()

  const {
    data: { listaMedicamento: medicamentos },
    loading,
  } = useMedicamentoUsoModalQuery({
    variables: {
      input: { prontuarioId, ativo: true, isAcompanhamentoPreNatal: true, pageParams: { unpaged: true } },
    },
    skip: !prontuarioId,
  })

  const medicamentosAgrupados = useMemo(() => {
    const listaMedicamento = medicamentos?.content as ReceitaMedicamento[]
    if (!RENOVACAO_PRESCRICAO_ENABLED) {
      return listaMedicamento
    }
    return getMedicamentosAgrupados(listaMedicamento)
  }, [medicamentos, RENOVACAO_PRESCRICAO_ENABLED])

  const medicamentosToShow = medicamentosAgrupados?.slice(0, 3)
  const medicamentosAccordion = medicamentosAgrupados?.slice(3)

  const renderMedicamentoRow = (index: number, receita: ReceitaMedicamento) => {
    return (
      <Fragment>
        {!!index && <Divider />}
        <MedicamentoEmUsoSection prontuarioId={prontuarioId} receita={receita} />
      </Fragment>
    )
  }

  return (
    <AcompanhamentoAccordionCard
      id='medicamentos-em-uso'
      title='Medicamentos em uso'
      itemName='medicamento'
      placeholder='Nenhum medicamento em uso'
      loading={loading}
      items={medicamentosToShow}
      accordionItems={medicamentosAccordion}
      renderRow={(index, receita) => renderMedicamentoRow(index, receita)}
    />
  )
}
